import React from "react";
// import flexible from '../../utils/flexible';
import "./index.less";

class UseCarRules extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  getParams = (url) => {
    const searchParams = {};
    if (url.includes("?")) {
      const params = new URLSearchParams(url.split("?").pop());
      for (const key of params.keys()) {
        Object.assign(searchParams, {
          [key]: params.get(key),
        });
      }
    }
    return searchParams;
  };
  render() {
    let list = {
      YL: "平台",
      ZNGC: "平台",
    };
    let flag = this.getParams(this.props.location.search).flag;
    let company = `${flag && list[flag] ? list[flag] : "绿色慧联"}`;
    // document.title = '';
    return (
      <div className="page_type_h5">
        <section id="useCarRules">
          <div className="top">
            <h2>用车须知</h2>
          </div>
          <div className="top time">更新时间:2020-01-01</div>
          <p>
            <br />
          </p>
          <div>
            <p className="content">
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;首先非常感谢您选择使用
              {company}
              的新能源车辆，以下事项对您非常重要，为了您的权利能够得到保障，请您在使用车辆前务必仔细阅读以下须知内容：
            </p>
          </div>
          <p>
            <br />
          </p>
          <div>
            <p className="serial-number">1.</p>
            <p className="content">
              {company}
              为您提供车辆车身及核心零部件的质量问题维修、保养及因车辆质量原因引起的故障救援服务，对于非车辆质量原因引起的维修、救援等费用由您自行承担（
              {company}服务电话： 4008262266 ）；
            </p>
          </div>
          <div>
            <p className="serial-number">2.</p>
            <p className="content">
              您在将车辆交还给{company}
              时，需保证车辆外观及内饰与交车时保持一致（合理的自然损耗、折旧除外），如车辆存在损坏，须按
              {company}维修标准报价进行赔偿；
            </p>
          </div>
          <div>
            <p className="serial-number">3.</p>
            <p className="content">
              您自接到{company}保养通知之日起 5 日内，将车辆送至{company}
              指定服务站进行保养，如您逾期未完成车辆保养，且{company}
              有权随时采取远程控车等措施，直至收回车辆，
              车辆因收回产生的全部费用由您承担；
            </p>
          </div>
          <div>
            <p className="serial-number">4.</p>
            <p className="content">
              您需到{company}指定的服务站进行车辆维修、保养车辆，您未按照约定在
              {company}指定地点维修、保养的，由您承担全部维修、保养费用；
            </p>
          </div>
          <div>
            <p className="serial-number">5.</p>
            <p className="content">
              您应承担车辆使用期间所产生的费用，包括但不限于充电费、通行费、停车费、违章扣分及罚款、道路救援费及各项易损件的更换/添加/维修费用（易损件包括但不限于：轮胎、防冻液、玻璃水、四轮定位、四轮动平衡等具体详见随车服务保修手册）；
            </p>
          </div>
          <div>
            <p className="serial-number">6.</p>
            <p className="content">
              租赁期内，如车辆行驶里程超出约定里程的，
              您应承担车辆超里程所产生的费用；
            </p>
          </div>
          <div>
            <p className="serial-number">7.</p>
            <p className="content">
              如您不按合同要求约定履行义务的（包括但不限于拖欠租金及服务费、不及时处理违章、不按时维修保养及年审车辆、逾期不还车、违规使用车辆等），在保障车辆安全的前提下，
              {company}
              有权采取远程控车等措施，因此产生的所有费用及风险由您承担（包含但不限于拖车救援费、停车费、违章罚款等）；
            </p>
          </div>
          <div>
            <p className="serial-number">8.</p>
            <p className="content">
              您应在公安交通管理部门开具罚单或收到{company}发出的违章处理的通知
              5 日内处理完毕， 并将处理结果、相关单据原件反馈至{company}
              ，逾期未处理的视为违约，{company}
              有权随时采取远程控车等措施，直至收回车辆，强制处理违章，因车辆收回及处理违章产生的全部费用由您承担；
            </p>
          </div>
          <div>
            <p className="serial-number">9.</p>
            <p className="content">
              保险公司理赔前您须先行垫付由于交通事故所造成的所有损失费用，包括但不限于垫付维修、赔偿第三方损失等费用，损失超出保险实际理赔范围的部分由您承担；
            </p>
          </div>
          <div>
            <p className="serial-number">10.</p>
            <p className="content">
              每次事故损失在 1000 元（含）以内的由您承担，事故损失在 1000
              元以上的可报保险赔付，您需承担 1000 元及{company}
              车辆加速折旧损失， 车辆折旧损失按{company}车损超出 1000 元部分的
              10%计算；上述费用，{company}
              有权从保险理赔款中扣除，不足部分在车辆保证金中扣除。
            </p>
          </div>
        </section>
      </div>
    );
  }
}

export default UseCarRules;



// WEBPACK FOOTER //
// ./src/staticPage/useCarRules/index.js